import { Fragment } from 'react';
import { ParameterField, StyledField } from '../../fields';

export default function IncidentParameters({ name, filters }) {
  return (
    <Fragment>
      <StyledField
        name={`${name}.number`}
        component={ParameterField}
        label="Number"
        type="text"
      />
      <StyledField
        name={`${name}.type^code`}
        component={ParameterField}
        label="Type"
        type="text"
        values={Object.entries(filters.types || {})}
      />
      <StyledField
        name={`${name}.responseCategory^code`}
        component={ParameterField}
        label="Response Category"
        type="text"
        values={[
          'Immediate Urban',
          'Immediate Rural',
          'Priority',
          'Scheduled',
          'Unknown',
        ]}
      />
      <StyledField
        name={`${name}.grade`}
        component={ParameterField}
        label="Grade"
        type="number"
      />
      <StyledField
        name={`${name}.status`}
        component={ParameterField}
        label="Status"
        type="text"
        values={['Opened', 'Assigned', 'Deployed', 'Attended', 'Closed']}
      />
      <StyledField
        name={`${name}.closingCodes@code`}
        component={ParameterField}
        label="Closing Code"
        type="text"
        values={Object.entries(filters.closingCodes || {})}
      />
    </Fragment>
  );
}
